import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { createContext, forwardRef, useContext } from 'react';
var LinkContext = /*#__PURE__*/createContext(
/*#__PURE__*/
// eslint-disable-next-line react/display-name
forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", _extends({}, props, {
      ref: ref
    }))
  );
}));
export function LinkProvider(props) {
  return /*#__PURE__*/React.createElement(LinkContext.Provider, {
    value: props.linkComponent
  }, props.children);
}
export function useLinkComponent() {
  return useContext(LinkContext);
}